import { AssistantCapabilities } from './AssistantPlayground.types'

export const assistantCapabilities: AssistantCapabilities = {
  version: '1.0',
  capabilities: [
    {
      title: 'Revolut Account Linking',
      description:
        'Your mobile app must be linked to your profile at people.revolut.com for access.',
    },
    {
      title: 'General Inquiries',
      description:
        'Get answers to questions about where to find and how to use Revolut products.',
    },
    {
      title: 'Data Retrieval & Analysis',
      description:
        'Supports transaction, balance, subscription, FX, and budget data analysis.',
    },
    {
      title: 'Insights & Advice',
      description:
        'Provides simple insights and advice when clicking on proactive insights in composer',
    },
  ],
}
